import React, { useState, ReactNode } from "react";

import { VerifyForm } from "../../forms/auth";
import { Modal, Message } from "../../../components/common";
import { VerifyProps } from "../../../types";
import { UIStatus } from "../../../types/GlobalTypes";

interface Props extends VerifyProps {
  children?: (fn: () => void) => ReactNode;
  open?: boolean;
  changeOpen?: (val: boolean) => void;
  formErrors?: String[] | any;
}

export const VerifyModal: React.FC<Props> = (props) => {
  const { open = false, changeOpen, formErrors } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const actionHandler = () => (changeOpen ? changeOpen(true) : setIsOpen(true));

  const callback = (args?: any) => {
    props.action && props.action(args);
    !changeOpen && setIsOpen(false);
  };

  return (
    <>
      <>{props.children && props.children(actionHandler)}</>
      <Modal
        isOpen={open || isOpen}
        close={() => (changeOpen ? changeOpen(false) : setIsOpen(false))}
        title="Verify it’s you"
        subtitle="Enter code from your authenticator app"
      >
        <VerifyForm action={callback} args={props.args} />

        {formErrors && (
          <div className="mt-12">
            {formErrors.map((err: string) => (
              <Message
                key={err}
                className="mb-6"
                text={err}
                type={UIStatus.ERROR}
              />
            ))}
          </div>
        )}
      </Modal>
    </>
  );
};
